module.exports = __webpack_public_path__ + "img/myh1.422c0e1c.jpg";